import { List, Details, CheckNoteSheet } from "../Components/index.js";

export default [
    {
        path: "/reports/account/check-list",
        component: List,
        name: "report.account.check.list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/account/check-print/:number",
        component: Details,
        name: "report.account.check.print",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/account/check-note-sheet/:number",
        component: CheckNoteSheet,
        name: "report.account.check.note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
];
